import type { HeaderResourceItem } from "@/types/types";

export function getDefaultHeaderResources(locale: string): HeaderResourceItem[] {
  const isVietnamese = locale === "vi";

  return [
    {
      key: "vvc-c3i5-datasheet",
      title: isVietnamese ? "Datasheet · VVC-C3I5" : "VVC-C3I5 Datasheet",
      group: isVietnamese ? "TÀI LIỆU CAMERA" : "CAMERA DOCUMENTS",
      link: "",
    },
    {
      key: "vi-c340-e-datasheet",
      title: isVietnamese ? "Datasheet · VI-C340-E" : "VI-C340-E Datasheet",
      group: isVietnamese ? "TÀI LIỆU CAMERA" : "CAMERA DOCUMENTS",
      link: "",
    },
    {
      key: "camera-configuration-guide",
      title: isVietnamese ? "Hướng dẫn thông số camera · VI-C340-E" : "Camera Configuration Guide · VI-C340-E",
      group: isVietnamese ? "TÀI LIỆU CAMERA" : "CAMERA DOCUMENTS",
      link: "",
    },
  ];
}

export function isGoogleDriveUrl(url: string | undefined | null): boolean {
  return /^https?:\/\/(drive|docs)\.google\.com\//i.test(url || "");
}
